import React, { useContext, useMemo } from "react";
import Shipments from "../Shipments/Shipments";
import { useLocation, useNavigate } from "react-router-dom";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import { useAppContextNonNull } from "@contexts/AppContext";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import { hasEditAccess } from "@services/ScreenOptionsService";
import ViewAccessService from "@services/ViewAccessService";

type Props = {};

export const ShipmentsWrapper = (props: Props) => {
    const { userModel, supplierModel, vendorModel, socket, uiContext } = useAppContextNonNull();

    const location = useLocation();
    const navigate = useNavigate();

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(ScreenOptionsEnum.SHIPPING, userModel, supplierModel, ViewAccessService.Shipments);
    }, [userModel, supplierModel]);

    return (
        <Shipments
            location={location}
            history={navigate}
            notifyFn={uiContext.notifyFn}
            getSidebarState={uiContext.getSidebarState}
            socket={socket}
            toggleSidebar={uiContext.toggleSidebar}
            setSidebarComponent={uiContext.setSidebarComponent}
            setActivityIndicator={uiContext.setActivityIndicator}
            supplierModel={supplierModel}
            userModel={userModel}
            vendorModel={vendorModel}
            isReadOnly={isReadOnly}
            uiContext={uiContext}
        />
    );
};
